import type { ReactNode } from 'react';

import { SkeletonLoader } from '@/components/loaders';
import { Text } from '@/components/typography';
import { numberFormat } from '@/helper/numberFormatter';

type Props = {
  label: ReactNode;
  value?: number;
  total?: number;
  isLoading: boolean;
  error: Error | null;
};

const RuleBuilderPreviewModalDetailRow = ({ label, value, total, isLoading, error }: Props) => {
  return (
    <div className="flex items-center justify-between border-t border-gray-500 px-4 py-3 last:border-b">
      <Text variant="caption1">{label}</Text>
      {error ? null : value != null ? (
        <Text variant="caption1">
          <strong>{numberFormat(value)}</strong>
          &nbsp;of&nbsp;
          {numberFormat(total)}
        </Text>
      ) : isLoading ? (
        <SkeletonLoader width={100} height={16}>
          <rect x="0" y="0" rx="2" ry="2" width="100%" height="100%" />
        </SkeletonLoader>
      ) : null}
    </div>
  );
};

export default RuleBuilderPreviewModalDetailRow;
